import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-print-logo-company',
    templateUrl: './print-logo-company.component.html',
    standalone: false
})
export class PrintLogoCompanyComponent {
    @Input() logoSrc: string|null|undefined;
}
